/**
 * 地图标记图标工具函数
 * 统一管理地图标记图标的生成逻辑
 */

/**
 * 生成司机定位轨迹标记图标
 * @param color 标记颜色（如 '#EA4335' 红色 或 '#4285F4' 蓝色）
 * @param number 标记上显示的数字
 * @param version 版本号（用于强制更新）
 * @returns Google Maps Symbol 对象（圆形标记）
 */
export const generateDriverLocationTrackMarkerIcon = (
  color: string,
  number: number,
  version: number
): google.maps.Symbol => {
  // 使用 Google Maps Symbol 而不是自定义图标
  return {
    path: google.maps.SymbolPath.CIRCLE,
    fillColor: color,
    fillOpacity: 0.9,
    strokeColor: '#FFFFFF',
    strokeWeight: 2,
    scale: 20, // 圆形大小
    labelOrigin: new google.maps.Point(0, 0), // 标签位置
  } as google.maps.Symbol;
};

